<template>
  <div id="hrms15e" class="page-hrms15e">
    <hrms-search-box-table v-show="indexDisp"
            v-model="searchIndex"
            :data="index"
            :nowLang="app.nowLang"
            :columns="columns[app.nowLang].index"
            :maxRowspan="maxRowspan.index"
            :unLoadBool="true"
            :receivedStore="receivedHrms15eIndex"
            searchBoxAlias="hrms15e"
            :callSearchEvent="callSearchEvent"
            :editEvent="editEvent"
            :deleteInlineEventBool="true"
            :deleteInlineBtnDisp="false"
            :saveInlineEvent="deleteEvent" />
    <detail v-if="detailDisp"
            :searchIndex="searchIndex"
            :labels="labels[app.nowLang]"
            :labelsButton="app.button[app.nowLang]"
            :dropdowns="dropdowns"
            :codappr="codempid"
            :descCodappr="app.currentUser.username[app.nowLang]"
            :detail="detail"
            :detailCourse="detailCourse"
            :popupCourseGap="popupCourseGap"
            :detail1Desc1Table="columns[app.nowLang].detail1Desc1Table"
            :detail2Desc1Table="columns[app.nowLang].detail2Desc1Table"
            :detail3Desc2Table="columns[app.nowLang].detail3Desc2Table"
            :detail3Desc3Table="columns[app.nowLang].detail3Desc3Table"
            :detail3InfoTable="columns[app.nowLang].detail3InfoTable"
            :courseGapPopupTable="columns[app.nowLang].courseGapPopupTable"
            :nowLang="app.nowLang"
            :toggle="toggle"
            :indexSelected="indexSelected"
            :detail3Selected="detail3Selected"
            :setDetail3Selected="setDetail3Selected"
            :detailDisabled="detailDisabled"
            :setDetailDisabled="setDetailDisabled"
            :detailDisabled2="detailDisabled2"
            :setDetailDisabled2="setDetailDisabled2"
            :detail3Desc3Disabled="detail3Desc3Disabled"
            :setDetail3Desc3Disabled="setDetail3Desc3Disabled"
            :detail3Disp="detail3Disp"
            :setDetail3Disp="setDetail3Disp"
            :detail3Desc3Disp="detail3Desc3Disp"
            :setDetail3Desc3Disp="setDetail3Desc3Disp"
            :detail3InfoDisp="detail3InfoDisp"
            :setDetail3InfoDisp="setDetail3InfoDisp"
            :receivedHrms15eDetailCourse="receivedHrms15eDetailCourse"
            :receivedHrms15eDetail3Desc1="receivedHrms15eDetail3Desc1"
            :receivedHrms15eDetailCourseAddInline="receivedHrms15eDetailCourseAddInline"
            :receivedHrms15eCourseGapPopup="receivedHrms15eCourseGapPopup"
            :receivedHrms15eDetail1Desc2="receivedHrms15eDetail1Desc2"
            :receivedHrms15eDetail2Desc2="receivedHrms15eDetail2Desc2"
            :receivedHrms15eDetail3Desc2="receivedHrms15eDetail3Desc2"
            :receivedHrms15eDetail3Desc3="receivedHrms15eDetail3Desc3"
            :receivedHrms15eDetail3Info="receivedHrms15eDetail3Info"
            :postDetail3InfoSave="postDetail3InfoSave"
            :setDetailCouresAddInlineAll="setDetailCouresAddInlineAll"
            :detail3InfoDesc1Disp="detail3InfoDesc1Disp"
            :setDetail3InfoDesc1Disp="setDetail3InfoDesc1Disp"
            :inlineDetail3Info="inlineDetail3Info"
            :setInlineDetail3Info="setInlineDetail3Info"
            :popupDetail3InfoDesc2="popupDetail3InfoDesc2"
            :detail3InfoDesc1Table="columns[app.nowLang].detail3InfoDesc1Table"
            :detail3InfoDesc2PopupTable="columns[app.nowLang].detail3InfoDesc2PopupTable"
            :receivedHrms15eDetail3InfoDesc1Popup="receivedHrms15eDetail3InfoDesc1Popup"
            :receivedHrms15eDetail3InfoDesc2Popup="receivedHrms15eDetail3InfoDesc2Popup"
            :postDetailCourseSave="postDetailCourseSave"
            :postDetail1Save="postDetail1Save"
            :postDetail2Save="postDetail2Save"
            :postStatusSave="postStatusSave"
            :postSendmail="postSendmail"
            :detailTab3Desc3Selected="detailTab3Desc3Selected"
            :setDetailTab3Desc3Selected="setDetailTab3Desc3Selected"
            :detail3Info="detail3Info"
            :detail3InfoSelected="detail3InfoSelected"
            :setDetail3InfoSelected="setDetail3InfoSelected"
            :detailTab1Desc2="detailTab1Desc2"
            :detailTab1Desc2Selected="detailTab1Desc2Selected"
            :setDetailTab1Desc2Selected="setDetailTab1Desc2Selected"
            :showDetailDescDisp="showDetailDescDisp"
            :setShowDetailDescDisp="setShowDetailDescDisp"
            :detailDisabled1="detailDisabled1"
            :setDetailDisabled1="setDetailDisabled1"
            :detail1Disp="detail1Disp"
            :setDetail1Disp="setDetail1Disp"
            :detail1Desc1Disp="detail1Desc1Disp"
            :setDetail1Desc1Disp="setDetail1Desc1Disp"
            :detailTab2Desc2="detailTab2Desc2"
            :detailTab2Desc2Selected="detailTab2Desc2Selected"
            :setDetailTab2Desc2Selected="setDetailTab2Desc2Selected"
            :detailDisabled3="detailDisabled3"
            :setDetailDisabled3="setDetailDisabled3"
            :detailTab3Desc1="detailTab3Desc1"
            :detailTab3Desc1Selected="detailTab3Desc1Selected"
            :setDetailTab3Desc1Selected="setDetailTab3Desc1Selected"
            :detail3Desc1Disp="detail3Desc1Disp"
            :setDetail3Desc1Disp="setDetail3Desc1Disp"
            :detailTab3Desc2="detailTab3Desc2"
            :detail3Desc2Disp="detail3Desc2Disp"
            :setDetail3Desc2Disp="setDetail3Desc2Disp"
            :detail3InfoLeftDisp="detail3InfoLeftDisp"
            :setDetail3InfoLeftDisp="setDetail3InfoLeftDisp"
            :detail3InfoDesc1CourseDisp="detail3InfoDesc1CourseDisp"
            :setDetail3InfoDesc1CourseDisp="setDetail3InfoDesc1CourseDisp"
            :detailTab3Desc3="detailTab3Desc3"
            :flgDisabled="flgDisabled"
            :detail3InfoIndexSelected="detail3InfoIndexSelected"
            :setDetail3InfoIndexSelected="setDetail3InfoIndexSelected"
            :detailTab3Desc3IndexSelected="detailTab3Desc3IndexSelected"
            :setDetailTab3Desc3IndexSelected="setDetailTab3Desc3IndexSelected"
            :detailTab1Desc2IndexSelected="detailTab1Desc2IndexSelected"
            :setDetailTab1Desc2IndexSelected="setDetailTab1Desc2IndexSelected"
            :detailTab2Desc2IndexSelected="detailTab2Desc2IndexSelected"
            :setDetailTab2Desc2IndexSelected="setDetailTab2Desc2IndexSelected"
            :sumscore="sumscore"
            :validateStaappr="validateStaappr"
            :flgProcess="flgProcess"
            :labelsHrms15e="labelsHrms15e[app.nowLang]"
            />
  </div>

</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/hrms15e/mutation-types'
import detail from 'components/hrms15e/detailComponent'
import moment from 'moment'

export default {
  name: 'hrms15e',
  data () {
    return {
      disabled: false,
      aaa: 1,
      app: this.$root.$children[0],
      searchIndex: {
        year: moment().format('YYYY'),
        numtime: '1'
      },
      validateStaappr: true,
      labelsHrms15e: {
        en: {
          C10: 'Abnormal Deduction',
          C20: 'Leave Deduction',
          C30: 'Punishment Deduction',
          C40: 'Scores',
          C50: 'No behavior assessment',
          C60: 'No assessment form',
          C70: 'No',
          C80: 'No competency assessment',
          C90: 'Net score',
          C100: 'All evaluation forms are not completely. Do you want to save?'
        },
        th: {
          C10: 'หักคะแนนผิดปกติ',
          C20: 'หักคะแนนการลา',
          C30: 'หักคะแนนการผิดวินัย',
          C40: 'คะแนน',
          C50: 'ไม่มีรายการประเมิน Behavior',
          C60: 'ไม่มีแบบฟอร์มการประเมิน',
          C70: 'ไม่มี',
          C80: 'ไม่มีรายการประเมิน Competency',
          C90: 'คะแนนสุทธิ',
          C100: 'ยังประเมินไม่ครบทุกข้อ ต้องการบันทึกหรือไม่'
        }
      }
    }
  },
  created () {
    this.receivedHrms15eColumnsLabels()
  },
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    ...mapGetters({
      indexDisp: types.GET_HRMS15E_INDEX_DISP,
      detailDisp: types.GET_HRMS15E_DETAIL_DISP,
      columns: types.GET_HRMS15E_COLUMNS,
      labels: types.GET_HRMS15E_LABELS,
      maxRowspan: types.GET_HRMS15E_MAX_ROWSPAN,
      dropdowns: types.GET_HRMS15E_DROPDOWNS,
      index: types.GET_HRMS15E_INDEX,
      indexSelected: types.GET_HRMS15E_INDEX_SELECTED,
      detail3Selected: types.GET_HRMS15E_DETAIL3_SELECTED,
      detail: types.GET_HRMS15E_DETAIL,
      detailCourse: types.GET_HRMS15E_DETAIL_COURSE,
      detailDisabled: types.GET_HRMS15E_DETAIL_DISABLED,
      detailDisabled1: types.GET_HRMS15E_DETAIL_DISABLED1,
      detailDisabled2: types.GET_HRMS15E_DETAIL_DISABLED2,
      detailDisabled3: types.GET_HRMS15E_DETAIL_DISABLED3,
      detail3Desc3Disabled: types.GET_HRMS15E_DETAIL3_DESC3_DISABLED,
      detail3Disp: types.GET_HRMS15E_DETAIL3_DISP,
      detail3Desc3Disp: types.GET_HRMS15E_DETAIL3_DESC3_DISP,
      inlineDetail3Info: types.GET_HRMS15E_DETAIL3_INFO_INLINE,
      detail3Info: types.GET_HRMS15E_DETAIL3_INFO,
      detail3InfoDisp: types.GET_HRMS15E_DETAIL3_INFO_DISP,
      detail3InfoDesc1Disp: types.GET_HRMS15E_DETAIL3_INFO_DESC1_DISP,
      popupCourseGap: types.GET_HRMS15E_COURSE_GAP_POPUP,
      popupDetail3InfoDesc2: types.GET_HRMS15E_DETAIL3_INFO_DESC2_POPUP,
      detailTab3Desc3IndexSelected: types.GET_HRMS15E_DETAIL3_DESC3_INDEX_SELECTED,
      detailTab3Desc3Selected: types.GET_HRMS15E_DETAIL3_DESC3_SELECTED,
      detail3InfoSelected: types.GET_HRMS15E_DETAIL3_INFO_SELECTED,
      detailTab1Desc2: types.GET_HRMS15E_DETAIL1_DESC2,
      detailTab1Desc2Selected: types.GET_HRMS15E_DETAIL1_DESC2_SELECTED,
      showDetailDescDisp: types.GET_HRMS15E_SHOW_DETAIL_DESC_DISP,
      detail1Disp: types.GET_HRMS15E_DETAIL1_DISP,
      detail1Desc1Disp: types.GET_HRMS15E_DETAIL1_DESC1_DISP,
      detailTab2Desc2: types.GET_HRMS15E_DETAIL2_DESC2,
      detailTab3Desc1: types.GET_HRMS15E_DETAIL3_DESC1,
      detailTab2Desc2Selected: types.GET_HRMS15E_DETAIL2_DESC2_SELECTED,
      detailTab3Desc1Selected: types.GET_HRMS15E_DETAIL3_DESC1_SELECTED,
      detailTab3Desc2: types.GET_HRMS15E_DETAIL3_DESC2,
      detail3Desc1Disp: types.GET_HRMS15E_DETAIL3_DESC1_DISP,
      detail3Desc2Disp: types.GET_HRMS15E_DETAIL3_DESC2_DISP,
      detail3InfoLeftDisp: types.GET_HRMS15E_DETAIL3_INFO_LEFT_DISP,
      detail3InfoDesc1CourseDisp: types.GET_HRMS15E_DETAIL3_INFO_DESC1_COURSE_DISP,
      detailTab3Desc3: types.GET_HRMS15E_DETAIL3_DESC3,
      flgDisabled: types.GET_HRMS15E_FLG_DISABLED,
      detail3InfoIndexSelected: types.GET_HRMS15E_DETAIL3_INFO_INDEX_SELECTED,
      detailTab1Desc2IndexSelected: types.GET_HRMS15E_DETAIL1_DESC2_INDEX_SELECTED,
      detailTab2Desc2IndexSelected: types.GET_HRMS15E_DETAIL2_DESC2_INDEX_SELECTED,
      sumscore: types.GET_HRMS15E_SUMSCORE,
      flgProcess: types.GET_HRMS15E_FLG_PROCESS
    })
  },
  methods: {
    pageDetail (event) {
      switch (event) {
        case 'edit':
          if (this.indexSelected.seqno) {
            this.setupParams()
          }
          break
        default:
          break
      }
    },
    setupParams () {
      let detailParams = {
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_codempid_query: this.indexSelected.codempid,
        p_codform: this.indexSelected.codform,
        p_numseq: this.indexSelected.numseq,
        p_codaplvl: this.indexSelected.codaplvl
      }
      let searchParams = {
        p_codempid: this.indexSelected.codempid,
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_numseq: this.indexSelected.numseq
      }
      this.receivedHrms15eDetail(detailParams)
      this.receivedHrms15eSumscore(searchParams)
      this.receivedHrms15eDetail3Info(detailParams)
      this.toggle('detail')
    },
    editEvent (param) {
      this.validateStaappr = (param.staappr === 'P')
      this.setIndexSelected(param)
      this.pageDetail('edit', param)
    },
    deleteEvent (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHrms15eDelete({ searchIndex: this.searchIndex, dataRowsHasFlg: dataRowsHasFlg })
        }
      })
    },
    callSearchEvent () {
      if (this.searchIndex.codemp93 !== '') {
        this.searchIndex.codcomp3 = ''
        this.searchIndex.codaplvl = ''
      }
    },
    ...mapMutations({
      setIndexSelected: types.SET_HRMS15E_INDEX_SELECTED,
      setDetail3Selected: types.SET_HRMS15E_DETAIL3_SELECTED,
      setDetailDisabled: types.SET_HRMS15E_DETAIL_DISABLED,
      setDetailDisabled1: types.SET_HRMS15E_DETAIL_DISABLED1,
      setDetailDisabled2: types.SET_HRMS15E_DETAIL_DISABLED2,
      setDetailDisabled3: types.SET_HRMS15E_DETAIL_DISABLED3,
      setDetail3Desc3Disabled: types.SET_HRMS15E_DETAIL3_DESC3_DISABLED,
      setDetail3Disp: types.SET_HRMS15E_DETAIL3_DISP,
      setDetail3Desc3Disp: types.SET_HRMS15E_DETAIL3_DESC3_DISP,
      setDetail3InfoDisp: types.SET_HRMS15E_DETAIL3_INFO_DISP,
      setInlineDetail3Info: types.SET_HRMS15E_DETAIL3_INFO_INLINE,
      setDetail3InfoDesc1Disp: types.SET_HRMS15E_DETAIL3_INFO_DESC1_DISP,
      setDetailCouresAddInlineAll: types.SET_HRMS15E_DETAIL_COURSE_ADD_INLINE_FROM_GAP,
      setDetailTab3Desc3IndexSelected: types.SET_HRMS15E_DETAIL3_DESC3_INDEX_SELECTED,
      setDetailTab3Desc3Selected: types.SET_HRMS15E_DETAIL3_DESC3_SELECTED,
      setDetail3InfoSelected: types.SET_HRMS15E_DETAIL3_INFO_SELECTED,
      setDetailTab1Desc2Selected: types.SET_HRMS15E_DETAIL1_DESC2_SELECTED,
      setShowDetailDescDisp: types.SET_HRMS15E_SHOW_DETAIL_DESC_DISP,
      setDetail1Disp: types.SET_HRMS15E_DETAIL1_DISP,
      setDetail1Desc1Disp: types.SET_HRMS15E_DETAIL1_DESC1_DISP,
      setDetailTab2Desc2Selected: types.SET_HRMS15E_DETAIL2_DESC2_SELECTED,
      setDetailTab3Desc1Selected: types.SET_HRMS15E_DETAIL3_DESC1_SELECTED,
      setDetail3Desc1Disp: types.SET_HRMS15E_DETAIL3_DESC1_DISP,
      setDetail3Desc2Disp: types.SET_HRMS15E_DETAIL3_DESC2_DISP,
      setDetail3InfoLeftDisp: types.SET_HRMS15E_DETAIL3_INFO_LEFT_DISP,
      setDetail3InfoDesc1CourseDisp: types.SET_HRMS15E_DETAIL3_INFO_DESC1_COURSE_DISP,
      setDetail3InfoIndexSelected: types.SET_HRMS15E_DETAIL3_INFO_INDEX_SELECTED,
      setDetailTab1Desc2IndexSelected: types.SET_HRMS15E_DETAIL1_DESC2_INDEX_SELECTED,
      setDetailTab2Desc2IndexSelected: types.SET_HRMS15E_DETAIL2_DESC2_INDEX_SELECTED
    }),
    ...mapActions({
      toggle: types.TOGGLE_HRMS15E_PAGE,
      receivedHrms15eColumnsLabels: types.RECEIVED_HRMS15E_DROPDOWNS_COLUMNS_LABELS,
      receivedHrms15eIndex: types.RECEIVED_HRMS15E_INDEX,
      receivedHrms15eDetail: types.RECEIVED_HRMS15E_DETAIL,
      receivedHrms15eDetailCourse: types.RECEIVED_HRMS15E_DETAIL_COURSE,
      receivedHrms15eDetailCourseAddInline: types.RECEIVED_HRMS15E_DETAIL_COURSE_ADD_INLINE,
      receivedHrms15eCourseGapPopup: types.RECEIVED_HRMS15E_COURSE_GAP_POPUP,
      receivedHrms15eDetail1Desc2: types.RECEIVED_HRMS15E_DETAIL1_DESC2,
      receivedHrms15eDetail2Desc2: types.RECEIVED_HRMS15E_DETAIL2_DESC2,
      receivedHrms15eDetail3Desc1: types.RECEIVED_HRMS15E_DETAIL3_DESC1,
      receivedHrms15eDetail3Desc2: types.RECEIVED_HRMS15E_DETAIL3_DESC2,
      receivedHrms15eDetail3Desc3: types.RECEIVED_HRMS15E_DETAIL3_DESC3,
      receivedHrms15eDetail3Info: types.RECEIVED_HRMS15E_DETAIL3_INFO,
      receivedHrms15eDetail3InfoDesc2Popup: types.RECEIVED_HRMS15E_DETAIL3_INFO_DESC2_POPUP,
      postDetail3InfoSave: types.POST_HRMS15E_DETAIL3_INFO_SAVE,
      postHrms15eDelete: types.POST_HRMS15E_DELETE,
      postDetail1Save: types.POST_HRMS15E_DETAIL1_SAVE,
      postDetail2Save: types.POST_HRMS15E_DETAIL2_SAVE,
      postStatusSave: types.POST_HRMS15E_STATUS_SAVE,
      postDetailCourseSave: types.POST_HRMS15E_DETAIL_COURSE_SAVE,
      postSendmail: types.POST_HRMS15E_SENDMAIL,
      receivedHrms15eSumscore: types.RECEIVED_HRMS15E_SUMSCORE
    })
  },
  components: {
    detail
  }
}
</script>

<style src="./style.scss" lang='scss'></style>



// WEBPACK FOOTER //
// component.vue?469cca72